import { LoadingOutlined } from '@ant-design/icons';
import { Card, Col, Row, Spin } from 'antd';
import React, { ReactElement } from 'react';
import { useSmoothScroll } from '../../../../../../../shared/hooks/useSmoothScroll';
import { formattedDate } from '../../../../../../../utils/dateTimeUtils';
import {ReactComponent as HIS_patient_img} from '../../../../../../../assets/images/svg/HIS-patient-old.svg';
import { getNestedValue, objectArrayToString } from '../../../../service/crmUtils';
import { isEmpty } from 'lodash';

const HISCard = ({ HISPatient, isSelected, index, loading }: any): ReactElement => {
  useSmoothScroll('scroll-HIS');

  const memberName = getNestedValue(HISPatient, ['patientName', 'patientDetails.patientName']);
  const mobile = getNestedValue(HISPatient, ['mobileNo', 'patientDetails.mobileNumber']);
  const lastAdmitDateTime = getNestedValue(HISPatient, ['treatmentDetails.dateOfAdmission']);
  const lastAdmitDoc = getNestedValue(HISPatient, ['doctorName', 'doctorDetails.doctorName']);
  const lineOfTreatment = getNestedValue(HISPatient, ['treatmentDetails.proposedLineOfTreatment']);
  const diagnosis = getNestedValue(HISPatient, ['diagnosis', 'treatmentDetails.diagnosis']);

  const formattedDOA = formattedDate(lastAdmitDateTime);
  const proposedLineOfTreatment = !isEmpty(lineOfTreatment) ? lineOfTreatment.name : '-';
  const combinedDiagnosis = Array.isArray(diagnosis) ? objectArrayToString(diagnosis) : diagnosis;

  return (
    <Card
      data-testid="benefCard"
      className={`scroll-HIS HIS-panel-styles ${isSelected ? 'patient-card-selected' : ''} card-selected mb-md`}
      hoverable={true}
    >
      <Row className="his-card" gutter={24}>
        <Col xs={4} sm={4} md={2} xl={2} className="HIS-doct-img">
          <HIS_patient_img />
        </Col>
        <Col xs={20} sm={20} md={22} xl={22}>
          <Row className="m-b-15">
            <Col xs={12} sm={12} md={6} xl={6}>
              <div className="his-label-title">Patient Name:</div>
              <div className="his-value">{memberName || '-'}</div>
            </Col>
            <Col xs={12} sm={12} md={6} xl={6}>
              <div className="his-label-title">Mobile No:</div>
              <div className="his-value">{mobile || '-'}</div>
            </Col>
            <Col xs={12} sm={12} md={6} xl={6}>
              <div className="his-label-title">DOA:</div>
              <div className="his-value">{formattedDOA || '-'}</div>
            </Col>
            <Col xs={12} sm={12} md={6} xl={6}>
              <div className="his-label-title">Doctor Name:</div>
              <div className="his-value">{lastAdmitDoc || '-'}</div>
            </Col>
          </Row>
          <Row>
            <Col xs={12} sm={12} md={6} xl={6}>
              <div className="his-label-title">Line of treatment:</div>
              <div className="his-value">{proposedLineOfTreatment || '-'}</div>
            </Col>
            <Col xs={12} sm={12} md={6} xl={6}>
              <div className="his-label-title">Diagnosis:</div>
              <div className="his-value">{combinedDiagnosis || '-'}</div>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row justify="end">
        {isSelected && loading && (
          <Spin indicator={<LoadingOutlined style={{ fontSize: 18, marginTop: '-20px' }} spin={true} />} />
        )}
      </Row>
    </Card>

  );
};

export default HISCard;
